import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import defaultPic from './default-pic.png'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { Link } from 'react-router'
import Masonry from 'react-masonry-component'
import GalleryItem from 'components/GalleryItem'
import Lightbox from 'react-images'
import styles from './AwardsSection.module.scss'

class AwardsSection extends React.Component {
  
  static propTypes () {
    return {
      data: React.PropTypes.array,
      type: React.PropTypes.string
    }
  }

  renderAward(aw) {
    let type = this.props.type || 'awards';
    return (
      <div className={styles.item}>
        {type === 'awards' &&
          <span>
            <span className={styles.prize}>{aw.prize}</span><br />
            <span className={styles.competition}>{aw.competition}</span><br />
            {aw.organization &&
              <small className={styles.organization}>{aw.organization}<br /></small>
            }
            {aw.time &&
              <small className={styles.time}>{aw.time}</small>
            }
            {aw.with &&
              <small className={styles.role}>, with {aw.with}<br /></small>
            }
          </span>
        } 
        {type === 'talks' &&
          <span>
            <span className={styles.prize}>{aw.role}</span><br />
            <span className={styles.competition}>{aw.topic}</span><br />
            <span className={styles.competition}>{aw.conference}</span><br />
            {aw.organization &&
              <small className={styles.organization}>{aw.organization}<br /></small>
            }
            {aw.time &&
              <small className={styles.time}>{aw.time}</small>
            }
            {aw.with &&
              <small className={styles.role}>, with {aw.with}<br /></small>
            }
            {aw.link &&
              <small><a href={aw.link} target="_blank">{(aw.linkTitle) ? aw.linkTitle : 'In the press' }</a></small>
            }
          </span>
        } 
        {/*
        
        {aw.pressLink &&
          <small><a href={aw.pressLink} target="_blank">In the press</a></small>
        }
        {aw.link &&
          <small><a href={aw.link} target="_blank">{(aw.linkTitle) ? aw.linkTitle : 'In the press' }</a></small>
        }
        
        */}

      </div>
    );
  }

  render () {
    var i = 0;
    let awards = _.map(this.props.data || [], item => ({...item, index: i++}));

    return (
      <Grid columns={12} className="center">
        <Breakpoint minWidth={700} widthMethod="componentWidth" className={styles.awards}>
          {_.chunk(awards, 2).map(aws => (
            (aws.length === 2) ? (
              <Grid columns={12} className="center">
                <Span columns={6} key={`${aws[0].prize} ${aws[0].competition}`} >
                  {this.renderAward(aws[0])}
                </Span>
                <Span columns={6} key={`${aws[1].prize} ${aws[1].competition}`} last>
                  {this.renderAward(aws[1])}
                </Span>
              </Grid>
            ) :
            <Grid columns={12} className="center">
              <Span columns={12} key={`${aws[0].prize} ${aws[0].competition}`} last>
                {this.renderAward(aws[0])}
              </Span>
            </Grid>
          ))}
        </Breakpoint>

        <Breakpoint maxWidth={700} widthMethod="componentWidth" className={styles.awards}>
          <Span columns={12}>
            {awards.map(aw => (
              <div key={`${aw.prize} ${aw.competition}`}>
                {this.renderAward(aw)}
              </div>
            ))}
          </Span>
        </Breakpoint>

      </Grid>
    )
  }
}

export default AwardsSection



/** WEBPACK FOOTER **
 ** ../components/AwardsSection.js
 **/